import { Card, Divider, Grid, makeStyles, Tooltip, Typography } from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';
import React, { useCallback, useContext } from 'react';

import { AccidentReviewControllerService, AccidentReviewDocumentDto } from '../../../api/client';
import { AccidentReviewContext } from '../accident-review-context';
import ActionContainer from './ActionContainer';

const useStyles = makeStyles(theme => ({
  card: {
    color: theme.palette.grey[600],
    margin: 10,

    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.primary.light,
    },
  },
  cardContent: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
}));

interface Props {
  data: AccidentReviewDocumentDto;
  onClick(): void;
  fetch(): void;
}

export default ({ data, fetch, onClick }: Props) => {
  const styles = useStyles();
  const { token } = useContext(AccidentReviewContext);

  const onClickCancel = useCallback(() => {
    AccidentReviewControllerService.deleteDocument(data.id, token).then(fetch);
  }, [data.id, fetch, token]);

  return (
    <Grid xs={12}>
      <Card className={styles.card}>
        <CardContent className={styles.cardContent}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={1}>
              <Typography variant="h6" component="h6">
                #{data.orderNum}
              </Typography>
            </Grid>
            <Divider orientation="vertical" flexItem />
            <Grid item xs={2}>
              <Typography variant="h6" component="h6">
                {data.documentType?.label}
              </Typography>
            </Grid>
            <Divider orientation="vertical" flexItem />

            <Grid item xs={7}>
              <Tooltip title={data.note}>
                <div>{data.note.substr(0, 50)}</div>
              </Tooltip>
            </Grid>

            <ActionContainer onClickPreview={onClick} onClickCancel={onClickCancel} />
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};
